/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
enum MimeTypes {
	html = "text/html",
	text = "text/plain",
	jpeg = "image/jpeg",
	jpg = "image/jpeg",
	png = "image/png",
	svg = "image/svg+xml",
	xml = "application/xml",
	json = "application/json",
	js = "text/javascript",
	css = "text/css",
	gif = "image/gif",
	webp = "image/webp",
	yaml = "application/yaml",
	pdf = "application/pdf",
	xls = "application/vnd.ms-excel",
	xlsx = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	docx = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	zip = "application/zip",
}

export default MimeTypes;
